import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/authService';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Component bảo vệ trang auth, chuyển hướng người dùng đã đăng nhập
 * Ngăn người dùng đã đăng nhập truy cập vào trang login
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const currentUser = AuthService.getCurrentUser();
  
  // Nếu đã đăng nhập và token còn hiệu lực, chuyển hướng về trang chính
  if (currentUser && !AuthService.isTokenExpired()) {
    // Chuyển hướng tùy theo vai trò người dùng
    if (currentUser.role === 'staff') {
      return <Navigate to="/staff/orders" replace />;
    } else {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }
  
  // Nếu token hết hạn, xóa thông tin đăng nhập và cho phép truy cập trang auth
  if (currentUser && AuthService.isTokenExpired()) {
    console.log('Token đã hết hạn, đang logout...');
    AuthService.logout();
  }
  
  // Cho phép truy cập trang auth nếu chưa đăng nhập
  return <>{children}</>;
};

export default AuthGuard;
